import { PublicClientApplication } from '@azure/msal-browser';
import { config } from '../config/config';

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI
  }
};

const msalInstance = new PublicClientApplication(msalConfig);

export const initializeMsal = async () => {
  await msalInstance.initialize();
};

export const loginRedirect = async () => {
  sessionStorage.setItem('azure_redirect_attempted', 'true');
  await msalInstance.loginRedirect({
    scopes: ['openid', 'profile', 'email', 'User.Read']
  });
};

const getUserPhoto = async (account) => {
  try {
    const tokenRequest = {
      scopes: ['User.Read'],
      account: account
    };
    
    const response = await msalInstance.acquireTokenSilent(tokenRequest);
    const photoResponse = await fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
      headers: {
        'Authorization': `Bearer ${response.accessToken}`
      }
    });
    
    if (photoResponse.ok) {
      const blob = await photoResponse.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.readAsDataURL(blob);
      });
    }
  } catch (error) {
    console.warn('Could not fetch user photo:', error);
  }
  return null;
};

export const hasAttemptedRedirect = () => {
  return sessionStorage.getItem('azure_redirect_attempted') === 'true';
};

export const clearRedirectFlag = () => {
  sessionStorage.removeItem('azure_redirect_attempted');
};

export const handleAuthReturn = async () => {
  try {
    await msalInstance.handleRedirectPromise();
    const accounts = msalInstance.getAllAccounts();
    
    if (accounts.length > 0) {
      const account = accounts[0];
      const photoUrl = await getUserPhoto(account);
      
      const user = {
        displayName: account.name,
        email: account.username,
        id: account.homeAccountId,
        photoUrl: photoUrl
      };
      
      localStorage.setItem('azure_user', JSON.stringify(user));
      localStorage.setItem('token_expires', new Date(Date.now() + 3600000).toISOString());
      clearRedirectFlag();
      return user;
    }
  } catch (error) {
    console.error('Auth error:', error);
  }
  
  return getCurrentUser();
};

export const logoutRedirect = async () => {
  localStorage.removeItem('azure_user');
  localStorage.removeItem('token_expires');
  await msalInstance.logoutRedirect();
};

export const logoutPopup = logoutRedirect;

export const getCurrentUser = async () => {
  const user = localStorage.getItem('azure_user');
  const expires = localStorage.getItem('token_expires');
  
  if (user && expires) {
    if (new Date() < new Date(expires)) {
      return JSON.parse(user);
    } else {
      await logoutRedirect();
    }
  }
  return null;
};

export const isAuthenticated = async () => {
  const user = await getCurrentUser();
  return user !== null;
};